<script>
  import MainPageHeader from "../components/MainPageHeader.svelte";
  import MainPageFooter from "../components/MainPageFooter.svelte";
  import { onMount } from 'svelte';
  import { AppController } from "../AppController";
  import { showLoading } from '../components/Overlay.svelte';
  import { form } from '../validate.js';
  import { toast, stickyToast } from '../components/Toast.svelte';

  // site key 6Lf9_t8gAAAAALLV4de5EZ1qjYcW9dqasoA2SkLM
  // secret key 6Lf9_t8gAAAAAF5GxVTExs1cHdNQKHJF_9Dz-V5e

  let alertAreas = []

  const SITE_KEY = "6Lf9_t8gAAAAALLV4de5EZ1qjYcW9dqasoA2SkLM";

  $: alertAreas;

  let resident = {
    alertArea: "",
    firstName: "",
    lastName: "",
    account: "",
    email: "",
    phoneNumber: "",
    cellNumber: "",
    houseNumber: "",
    street: "",
    unit: "",
    poBox: "",
    country: "",
    county: "",
    state: "",
    city: "",
    postalCode: "",
    preferredLanguage: "English",
    numberOfChildren: "",
    numberOfPets: "",
    captcha: ""
  }

  const { validate, ...residentForm} = form(() => ({
    // account: { value: resident.ubmax_acc, validators: [ (acc) => acc ] },
    alertArea: { value: resident.alertArea, validators: ["required"]},
    firstName: { value: resident.firstName, validators: ["required", "min:1"]},
    lastName: { value: resident.lastName, validators: ["required", "min:1"]},
    city: { value: resident.city, validators: ["required", "min:1"]},
    state: { value: resident.state, validators: ["required", "min:2"]},
    postalCode: { value: resident.postalCode, validators: ["required", "postal"]},
    captcha: { value: resident.captcha, validators: ["required"]}
  }));

  onMount(async () => {
    window.handleCaptchaCallback = handleCaptchaCallback;
    window.handleCaptchaError = handleCaptchaError;
    window.resetCaptcha = resetCaptcha;
    try {
      showLoading(true);
      alertAreas = await AppController.getAlertAreas();
    } catch (err) {
      console.log(err)
    } finally {
      showLoading(false);
    }
  });

  const save = async () => {
    try {
      showLoading(true);
      await AppController.emailResidentRequest(resident);
      toast('success', 10000, 'Saved', 'Request sent successfully');
    } catch (err) {
      console.log(err);
      stickyToast('danger', 'Error', 'An error occured sending your request.');
    } finally {
      showLoading(false);
    }
  }

  const handleCaptchaCallback = (token) => {
    resident.captcha = token;
  }

  const resetCaptcha = () => {
    resident.captcha = "";
  }

  const handleCaptchaError = () => {
    console.log('captcha error');
  }
</script>

<div class='container-fluid m-0 p-0'>
  <MainPageHeader />
  <div class='m-0 p-0'style='background-image: url("images/bg2.jpg");'>
    <div class='ml-5'>
      <h3 class="page-title">
        Create/Update Resident Account
      </h3>
      <h4>Community Notice -</h4>
      <p>
        In order to maintain a secure and up-to-date database for Public Alerts we require you to fill out the form below as complete as possible. Every fields is important but the <span class='text-danger'>*</span> fields have to be correct in the system for Alerts to be received. You can visit this site anytime you find it necessary to update your contact information. When completed it will be emailed to the City Clerk. The reason for the number of children or pets is to collect data for possible interface with the Fire Department.
      </p>
      <div class="row">
        <div class="col-md-6 form-group">
          <form class="forms-sample">
            <div class="form-group">
              <label for="public_alert_area" class='required-field'>Public Alert Area</label>
                <select 
                  id="public_alert_area" 
                  class="form-control" 
                  name="public_alert_area"
                  bind:value={resident.alertArea} 
                  use:validate={resident.alertArea}>
                  <option value="null">-- Please Select --</option>
                  {#each alertAreas as alertArea}
                    <option value={alertArea.id}>
                      {alertArea.company}
                    </option>
                  {/each}
                </select>		
            </div>

            <div class="form-group">
              <label class="control-label">Billing Account (if available)</label>
              <input 
                id="bill_ac_no" 
                class="form-control" 
                name="bill_ac_no" 
                type="text"
                bind:value={resident.account} >
            </div>

            <div class="form-group">
              <label class="control-label">Email</label>
              <input 
                id="email" 
                class="form-control" 
                name="email" 
                type="email"
                bind:value={resident.email} >
            </div>

            <div class="form-group">
              <label class="control-label">First Name<span class="text-danger">*</span></label>
              <input 
              id="first_name" 
              class="form-control" 
              class:border-danger={!$residentForm.firstName.valid && $residentForm.firstName.dirty}
              name="first_name" 
              type="text"
              bind:value={resident.firstName} 
              use:validate={resident.firstName}>	
              {#if $residentForm.firstName.errors.includes('required') && $residentForm.firstName.dirty}
                <p class='text-danger text-small'>First name is required</p>
              {/if}		
            </div>

            <div class="form-group">
              <label class="control-label">Last Name<span class="text-danger">*</span></label>
              <input 
              id="last_name" 
              class="form-control"
              name="last_name" 
              type="text"
              class:border-danger={!$residentForm.lastName.valid && $residentForm.lastName.dirty}
              bind:value={resident.lastName} 
              use:validate={resident.lastName}>	
              {#if $residentForm.lastName.errors.includes('required') && $residentForm.lastName.dirty}
                <p class='text-danger text-small'>Last name is required</p>
              {/if}				
            </div>

            <div class="form-group">
              <label class="control-label">Phone Number</label>
              <input 
                id="phone_number" 
                class="form-control" 
                name="phone_number" 
                type="text"
                bind:value={resident.phoneNumber} >
            </div>

            <div class="form-group">
              <label class="control-label">Cell Number</label>
              <input 
                id="cell_number" 
                class="form-control" 
                name="cell_number" 
                type="text"
                bind:value={resident.cellNumber} >
            </div>

            <div class="form-group">
              <label class="control-label">House Number</label>
              <input 
                id="house_number" 
                class="form-control" 
                name="house_number" 
                type="text"
                bind:value={resident.houseNumber} >
            </div>

            <div class="form-group">
              <label class="control-label">Street Name</label>
              <input 
                id="street_name" 
                class="form-control" 
                name="street_name" 
                type="text"
                bind:value={resident.street} >
            </div>

            <div class="form-group">
              <label class="control-label">Unit/Apt</label>
              <input 
                id="unit" 
                class="form-control" 
                name="unit" 
                type="text"
                bind:value={resident.unit} >
            </div>

            <div class="form-group">
              <label class="control-label">PO Box</label>
              <input 
                id="po_box" 
                class="form-control" 
                name="po_box" 
                type="text"
                bind:value={resident.poBox} >
            </div>

            <div class="form-group">
              <label class="control-label">Country</label>
              <input
                id="country" 
                class="form-control" 
                name="country" 
                type="text"
                bind:value={resident.country} >
            </div>

            <div class="form-group">
              <label class="control-label">County</label>
              <input 
                id="county" 
                class="form-control" 
                name="county" 
                type="text"
                bind:value={resident.county} >
            </div>

            <div class="form-group">
              <label class="control-label">State<span class="text-danger">*</span></label>
              <input 
              id="state" 
              class="form-control"
              name="state" 
              type="text"
              class:border-danger={!$residentForm.state.valid && $residentForm.state.dirty}
              bind:value={resident.state} 
              use:validate={resident.state}>
              {#if $residentForm.state.errors.includes('required') && $residentForm.state.dirty}
                <p class='text-danger text-small'>State is required</p>
              {/if}		
            </div>

            <div class="form-group">
              <label class="control-label">City<span class="text-danger">*</span></label>
              <input 
              id="city" 
              class="form-control"
              name="city"
              type="text"
              class:border-danger={!$residentForm.city.valid && $residentForm.city.dirty}
              bind:value={resident.city} 
              use:validate={resident.city}>	
              {#if $residentForm.city.errors.includes('required') && $residentForm.city.dirty}
                <p class='text-danger text-small'>City is required</p>
              {/if}	
            </div>

            <div class="form-group">
              <label class="control-label">Zip<span class="text-danger">*</span></label>
              <input 
              id="zip" 
              class="form-control" 
              name="zip" 
              type="text"
              class:border-danger={!$residentForm.postalCode.valid && $residentForm.postalCode.dirty}
              bind:value={resident.postalCode} 
              use:validate={resident.postalCode}>	
              {#if $residentForm.postalCode.errors.includes('required') && $residentForm.postalCode.dirty}
                <p class='text-danger text-small'>Zip is required</p>
              {/if}	
            </div>

            <div class="form-group">
              <label class="control-label">Preferred Language<span class="text-danger">*</span></label>
              <select 
                id="language" 
                class="form-control" 
                name="language"
                bind:value={resident.preferredLanguage} >
                <option value="0">English</option>
                <option value="1">Spanish</option>
              </select>	
            </div>

            <div class="form-group">
              <label class="control-label">Number of Children</label>
              <input 
                id="children" 
                class="form-control" 
                name="children" 
                type="text"
                bind:value={resident.numberOfChildren} >
            </div>

            <div class="form-group">
              <label class="control-label">Number of Pets</label>
              <input 
                id="pets" 
                class="form-control" 
                name="pets" 
                type="text"
                bind:value={resident.numberOfPets} >
            </div>

            <div
              class="g-recaptcha mb-2"
              data-sitekey={SITE_KEY}
              data-callback="handleCaptchaCallback"
              data-expired-callback="resetCaptcha"
              data-error-callback="handleCaptchaError"
            />

            <div class="form-group" id="submit_btn_div">
              <input class="btn btn-primary" class:disabled={!$residentForm.valid} disabled={!$residentForm.valid}  on:click|preventDefault={save} value="Submit">
            </div>
          </form>    
        </div>
      </div>
    </div>
  </div>
  <MainPageFooter />
</div>